import React, { FC, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { TQuickLinksProps } from './types/quickLinks.types';
import { QuickLinksModel } from './models/quickLinks.model';
import QuickLinksLink from './components/quickLinksLink';
import useMediaQuery from '../../hooks/useMediaQuery';
import './styles.scss';
import breakpoints from '../../constants/breakpoints.constants';
import { documentService, windowService } from '../../utils/window.utils.js';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import useStickyWrapper from '../../hooks/useStickyWrapper';
import useEEActive from '../../hooks/useEEActive';

const QuickLinks: FC<TQuickLinksProps> = (props: TQuickLinksProps) => {
  const model = new QuickLinksModel(props);
  const isWide = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const arr = isWide ? model.desktopLinks : model.mobileLinks;
  const stickyWrapperEle = useStickyWrapper();
  const isEE = useEEActive();

  useEffect(() => {
    if (!windowService()?.innerWidth) return;
    if (windowService()?.innerWidth < breakpoints['tbl-p'] && model.mobileLinks?.length > 0) {
      documentService().body.style.setProperty('--quick-links-mbl-height', '64px');
    }
    return (): void => {
      documentService().body.style.setProperty('--quick-links-mbl-height', 0);
    };
  }, [model.mobileLinks, props]);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  const generateLinks = arr.slice(0, 7).map((item, i) => {
    if (i === arr.length - 1) {
      item.last = true;
    }
    return <QuickLinksLink {...item} key={item?.id} />;
  });

  if (arr?.length === 0) {
    return null;
  }

  const quickLink = (
    <div className="quick-links">
      <ul className="quick-links__wrapper">{generateLinks}</ul>
    </div>
  );

  if (isEE) return quickLink;

  if (!stickyWrapperEle) return null;

  return <section>{createPortal(quickLink, stickyWrapperEle)}</section>;
};

export default QuickLinks;
